import {firstValueFrom, from, Observable} from "rxjs";
import {Contact} from "@app/core/contact/domain/contact";
import {Injectable} from "@angular/core";
import {ContactRemote} from "@app/core/contact/domain/contact.remote";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";

/**
 * Use case for contacting the customer service.
 */
@Injectable({
    providedIn: "root",
})

export class ContactUseCase {

    constructor(
        private contactService: ContactRemote,
        private deliveryPointLocal: DeliveryPointLocal
    ) {
    }

    /**
     * It contacts the customer service with the given contact data.
     * @param contact - The contact data to send.
     * @returns An observable that emits when the contact is successful.
     */
    execute(contact: Contact): Observable<void> {
        return from(this.contact(contact))
    }

    async contact(contact: Contact): Promise<void> {
        const deliveryPointCode = await firstValueFrom(this.deliveryPointLocal.currentDeliveryPointCode$)
        return firstValueFrom(this.contactService.contact(contact, deliveryPointCode))
    }

}
